export default {
    API_ENDPOINT: 'https://ancient-springs-93082.herokuapp.com/'
}

//API_ENDPOINT: 'http://localhost:8000/api'
//API_ENDPOINT: 'http://localhost:9090'
//https://ancient-springs-93082.herokuapp.com/